/*!
 * Keio Academy of New York - Online System
 * kanyos v3.0.0 (Author: Charlie YAN)
 * Copyright © 2007-2022 Anzas International
 */
(function ($) {
  'use strict'

  // Window Object
  var $window = $(window)

  // Window Default Config
  var DEFAULT_WINDOW_CONFIG = {
    // Layout Config
    layout: {
      centralBox: {
        triggerInit: true
      },
      contentSideNav: {
        triggerInit: true,
        collapse: false
      },
      backtoTop: {
        animationDuration: 800,
        visibleScrollTop: 400
      }
    },
    // Components Config
    connectedSortable: {
      triggerInit: true
    },
    blueimpGallery: {
      triggerInit: true,
      closeOnSlideClick: false,
      fullscreen: true
    },
    photoSwipeGallery: {
      triggerInit: true
    },
    paginationGo: {
      callback: undefined
    }
  }

  var SELECTOR_TOOLTIP = '[data-toggle="tooltip"]'
  var SELECTOR_LAZYLOAD = '[data-widget="lazyload"]'
  var SELECTOR_POPOVER = '[data-toggle="popover"]'

  // Component Selectors
  var SELECTOR_BLUEIMP_GALLERY_LINKS = '[data-toggle="blueimp-gallery"]'
  var SELECTOR_PHOTOSWIPE_GALLERY = '[data-toggle="photoswipe-gallery"]'
  var SELECTOR_CONNECTED_SORTABLE = '.connectedSortable'
  // var SELECTOR_CONTROL_SIDEBAR = '.control-sidebar'
  // var SELECTOR_CONTROL_SIDEBAR_TOGGLE_BUTTON = '[data-widget="control-sidebar"]'

  // fetch('../user-student/data/test.json')
  //   .then(function (response) {
  //     return response.json()
  //   })
  //   .then(function (myJson) {
  //     console.log(myJson)
  //   })

  $(document).on('click', '[data-toggle="display-dropdown-menu"]', function () {
    var target = $(this).data('target')
    $(target).trigger('click')
  })

  $(document).on('click', '#display-dropdown-menu', function (e) {
    e.stopPropagation()
  })

  $(document).on('click', '#display-dropdown-menu .dropdown-item', function () {
    var target = $(this).data('target')
    var checkMark = $(this).find('i.fas')
    if (checkMark.hasClass('fa-eye')) {
      checkMark.removeClass('fa-eye')
      checkMark.addClass('fa-eye-slash')
      $(target).slideUp()
    } else {
      checkMark.removeClass('fa-eye-slash')
      checkMark.addClass('fa-eye')
      $(target).slideDown()
    }
  })

  // $.fn.extend({
  //   loadingWidget: function (method) {
  //     switch (method) {
  //       case 'init':
  //         var loadingWidget = $(this).data('loadingWidget')
  //         var isLoadingWrapper = loadingWidget !== undefined && loadingWidget === '#_loading__Wrapper'
  //         var $loadingWidgetEl = $('<div />',
  //           loadingWidget ?
  //             {
  //               class: 'loading loading-widget',
  //               id: loadingWidget.replace('#', '')
  //             } :
  //             {
  //               class: 'loading loading-widget'
  //             })
  //           .append(
  //             $('<div />',
  //               {
  //                 class: 'loading-mask'
  //               }))
  //           .append(
  //             $('<div />',
  //               {
  //                 class: isLoadingWrapper ? 'loading-wrapper' : 'loading-partial d-flex justify-content-center align-items-center'
  //               })
  //               .append(
  //                 $('<img />', {
  //                   src: isLoadingWrapper ? '../../img/loading-wrapper.gif' : '../../img/loading-partial.gif'
  //                 })
  //               )
  //           )
  //         $(this).prepend($loadingWidgetEl)
  //         $(this).loadingWidget('show')
  //         break
  //       case 'show':
  //         $(this).find('.loading-widget').show()
  //         break
  //       case 'hide':
  //         break
  //       default:
  //         break
  //     }
  //   }
  // })

  // var createLoadingElement = function (el) {
  //   var loadingWidget = el.data('loadingWidget')
  //   console.debug(loadingWidget)
  //   var isLoadingWrapper = loadingWidget && loadingWidget === '#_loading__Wrapper'
  //   console.debug(isLoadingWrapper)
  //   return $('<div />',
  //     loadingWidget ?
  //       {
  //         class: 'loading',
  //         id: loadingWidget.replace('#', '')
  //       } :
  //       {
  //         class: 'loading loading-widget'
  //       })
  //     .append(
  //       $('<div />',
  //         {
  //           class: 'loading-mask'
  //         }))
  //     .append(
  //       $('<div />',
  //         {
  //           class: isLoadingWrapper ? 'loading-wrapper' : 'loading-partial d-flex justify-content-center align-items-center'
  //         })
  //         .append(
  //           $('<img />', {
  //             src: isLoadingWrapper ? '../../img/loading-wrapper.gif' : '../../img/loading-partial.gif'
  //           })
  //         )
  //     )
  // }

  // $('.loading-panel').each(function () {
  //   // $(this).prepend(createLoadingElement($(this)))
  //   // $(this).loadingWidget('init')
  // })

  // var showLoading = function (el) {
  //   var widget = el.data('widget')
  //   if (widget) {
  //     $(widget).show()
  //   } else {
  //     $('#_loading__Wrapper').show()
  //   }
  // }

  // var hideLoading = function (el) {
  //   var target = el.data('target')
  //   if (target) {
  //     $(target).hide()
  //   } else {
  //     $('#_loading__Wrapper').hide()
  //   }
  // }

  // $(document).on('change', 'select.loading-control', function () {
  //   // showLoading($(this))
  // })

  // $(document).on('click', 'a:not(.toggle), button:not(.toggle)', function () {
  //   // e = e || window.event
  //   // if (e.preventDefault) {
  //   //   e.preventDefault()
  //   // } else {
  //   //   e.returnValue = false
  //   // }
  //   var target = $(this).attr('target')
  //   if ((!target || target === 'self' || target === 'top')) {
  //     // showLoading($(this))
  //   }
  // })

  // $('.view-alt').show()
  // $('.edit-alt').hide()
  // $(document).on('click', '[data-toggle="edit-alt"],[data-toggle="view-alt"]', function (e) {
  //   e = e || window.event
  //   if (e.preventDefault) {
  //     e.preventDefault()
  //   } else {
  //     e.returnValue = false
  //   }

  //   var toggle = $(this).data('toggle')
  //   var target = $(this).data('target')
  //   var selector = '.' + toggle + ', ' + target
  //   $(selector).show()

  //   var dismiss = $(this).data('dismiss')
  //   $('.' + dismiss).hide()
  // })

  // 【Conected Sortable】 Init
  // ----------------------------------------------------------------------
  var initConnectedSortable = function (connectedSortableSelector) {
    var config = $.extend({}, DEFAULT_WINDOW_CONFIG, window.config)
    if (!config.connectedSortable.triggerInit) {
      return
    }

    // Make the dashboard widgets sortable Using jquery UI
    $(connectedSortableSelector).sortable({
      placeholder: 'sort-highlight',
      connectWith: connectedSortableSelector,
      handle: '.card-header, .nav-tabs',
      forcePlaceholderSize: true,
      zIndex: 999999
    })
    $(connectedSortableSelector + ' .card-header').css('cursor', 'move')
  }
  // ----------------------------------------------------------------------

  // 【Blueimp Gallery】 Init
  // ----------------------------------------------------------------------
  // find nearest parent element
  var getFunctionalTargetElement = function getFunctionalTargetElement(el, fn) {
    return el && (fn(el) ? el : getFunctionalTargetElement(el.parentNode, fn))
  }

  var initBlueimpGallery = function (gallerySelector) {
    var config = $.extend({}, DEFAULT_WINDOW_CONFIG, window.config)
    if (!config.blueimpGallery.triggerInit) {
      return
    }

    var $blueimpGalleryLinks = $(gallerySelector)
    $blueimpGalleryLinks.on('click', function (event) {
      event = event || window.event
      var target = event.target || event.srcElement
      var link = target.src ? target.parentNode : target
      var options = {
        index: link,
        event: event,
        closeOnSlideClick: config.blueimpGallery.closeOnSlideClick,
        fullscreen: config.blueimpGallery.fullscreen
      }
      var links = $.makeArray($blueimpGalleryLinks)
      // eslint-disable-next-line no-undef
      blueimp.Gallery(links, options) // eslint-disable-line new-cap
    })
  }
  // ----------------------------------------------------------------------

  // 【PhotoSwipe Gallery】 Init
  // ----------------------------------------------------------------------
  var initPhotoSwipeGallery = function (gallerySelector) {
    var config = $.extend({}, DEFAULT_WINDOW_CONFIG, window.config)
    if (!config.photoSwipeGallery.triggerInit) {
      return
    }

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
      e = e || window.event
      // e.preventDefault ? e.preventDefault() : e.returnValue = false
      if (e.preventDefault) {
        e.preventDefault()
      } else {
        e.returnValue = false
      }

      var eTarget = e.target || e.srcElement

      // find root element of slide
      var clickedListItem = getFunctionalTargetElement(eTarget, function (el) {
        return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
      })

      if (!clickedListItem) {
        return
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode
      var childNodes = clickedListItem.parentNode.childNodes
      var numChildNodes = childNodes.length
      var nodeIndex = 0
      var index

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex
          break
        }

        nodeIndex++
      }

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery)
      }

      return false
    }

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      // parse slide data (url, title, size ...) from DOM elements
      // (children of gallerySelector)
      var parseThumbnailElements = function (el) {
        var thumbElements = el.childNodes
        var numNodes = thumbElements.length
        var items = []
        var figureEl
        var linkEl
        var size
        var item

        for (var i = 0; i < numNodes; i++) {
          figureEl = thumbElements[i] // <figure> element

          // include only element nodes
          if (figureEl.nodeType !== 1) {
            continue
          }

          linkEl = figureEl.children[0] // <a> element
          if (linkEl.tagName.toUpperCase() !== 'A') {
            continue
          }

          size = linkEl.getAttribute('data-size').split('x')

          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: Number.parseInt(size[0], 10),
            h: Number.parseInt(size[1], 10)
          }

          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src')
          }

          item.el = figureEl // save link to element for getThumbBoundsFn
          items.push(item)
        }

        return items
      }

      var pswpElement = document.querySelectorAll('.pswp')[0]
      var gallery
      var options
      var items

      items = parseThumbnailElements(galleryElement)

      // define options (if needed)
      options = {

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),

        getThumbBoundsFn: function (index) {
          // See Options -> getThumbBoundsFn section of documentation for more info
          var thumbnail = items[index].el.getElementsByTagName('img')[0]// find thumbnail
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          var rect = thumbnail.getBoundingClientRect()

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
        },

        // Share buttons
        //
        // Available variables for URL:
        // {{url}}             - url to current page
        // {{text}}            - title
        // {{image_url}}       - encoded image url
        // {{raw_image_url}}   - raw image url
        shareButtons: [
          { id: 'download', label: '<i class="fa fa-download mr-1"></i>Download', url: '{{raw_image_url}}', download: true }
        ],

        closeElClasses: []
      }

      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid === index) {
              options.index = j
              break
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = Number.parseInt(index, 10) - 1
        }
      } else {
        options.index = Number.parseInt(index, 10)
      }

      // exit if index not found
      if (Number.isNaN(options.index)) {
        return
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options) // eslint-disable-line no-undef
      gallery.init()
    }

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector)

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      // galleryElements[i].setAttribute('data-pswp-uid', i + 1)
      // galleryElements[i].onclick = onThumbnailsClick
      galleryElements[i].pswpUid = i + 1
      galleryElements[i].addEventListener('click', onThumbnailsClick)
    }

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
      // var hash = window.location.hash.substring(1)
      var hash = window.location.hash.slice(1)
      var params = {}

      if (hash.length < 5) {
        return params
      }

      var vars = hash.split('&')
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue
        }

        var pair = vars[i].split('=')
        if (pair.length < 2) {
          continue
        }

        params[pair[0]] = pair[1]
      }

      if (params.gid) {
        params.gid = Number.parseInt(params.gid, 10)
      }

      return params
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash()
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
    }
  }

  // ----------------------------------------------------------------------

  // 【Window】 Init
  // ----------------------------------------------------------------------
  var initComponents = function () {
    initBlueimpGallery(SELECTOR_BLUEIMP_GALLERY_LINKS)
    initPhotoSwipeGallery(SELECTOR_PHOTOSWIPE_GALLERY)
    initConnectedSortable(SELECTOR_CONNECTED_SORTABLE)
  }

  var initGlobal = function () {
    // <!-- Resolve conflict in jQuery UI tooltip with Bootstrap tooltip -->
    $.widget.bridge('uibutton', $.ui.button)

    // Bootstrap Tooltip Init
    $(SELECTOR_TOOLTIP).tooltip()

    // Image Lazy Load Init
    $(SELECTOR_LAZYLOAD).lazyload()

    // Bootstrap Popover Init
    $(SELECTOR_POPOVER).popover()
  }

  $window.on('load', function () {
    initGlobal()
    initComponents()
  })
  // ----------------------------------------------------------------------

  $.showModalDialog = function (modalFade, modalDialog, options, classOptions) {
    if (modalDialog.hasClass('modal-sm')) {
      modalDialog.removeClass('modal-sm')
    }

    if (modalDialog.hasClass('modal-lg')) {
      modalDialog.removeClass('modal-lg')
    }

    if (modalDialog.hasClass('modal-xl')) {
      modalDialog.removeClass('modal-xl')
    }

    if (modalDialog.hasClass('modal-xl')) {
      modalDialog.removeClass('modal-xl')
    }

    if (modalDialog.hasClass('modal-dialog-centered')) {
      modalDialog.removeClass('modal-dialog-centered')
    }

    if (modalDialog.hasClass('modal-dialog-scrollable')) {
      modalDialog.removeClass('modal-dialog-scrollable')
    }

    modalDialog.addClass(classOptions.size)
    modalDialog.addClass(classOptions.centered)
    modalDialog.addClass(classOptions.scrollable)

    modalFade.modal(options)
  }

  $.hideModalDialog = function (modalFade) {
    modalFade.modal('hide')
  }
})(jQuery)
